import styled from 'styled-components';
import Theme from '../../../../styles/models/theme';
import CircleIconButton from '../../../atoms/Buttons/CircleIconButton';
import Icon from '../../../atoms/Icon';

export const ExternalContainer = styled.div`
  position: fixed;
  width: 100%;
  box-sizing: border-box;
`;

export const Container = styled.div<{theme?: Theme}>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${({theme}) => theme.white};
  padding: 15px;
`;

export const InnerContainer = styled.div<{align?: string}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 50%;
  justify-content: ${({align}) => align || 'flex-start'};
`;

export const HeaderTitle = styled.text<{theme: Theme}>`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: ${({theme}) => theme.secondary};
  padding-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const IconButton = styled(CircleIconButton)<{right?: number}>`
    margin-left: 5px;
    margin-right ${({right}) => (right ? `${right}px` : 0)};
`;

export const Separator = styled.div<{theme?: Theme}>`
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.chatSeparator};
  border-bottom-style: solid;
  width: 100%;
`;

export const BackButton = styled(Icon)`
  margin-right: 10px;
  &:active {
    opacity: 0.8;
  }
`;
